import {MutableRefObject, useEffect} from "react";
import {useServices} from "../../hooks/use-services.hook";

export function usePageHeader(pageHeaderElementRef: MutableRefObject<HTMLElement | null>) {
    const services = useServices();
    useEffect(() => {
        services.pageHeader.setHtmlElement(pageHeaderElementRef.current);
        return () => services.pageHeader.setHtmlElement(null);
    }, [services.pageHeader, pageHeaderElementRef]);
}